export default "import { CCol } from './CCol'\nimport { CContainer } from './CContainer'\nimport { CRow } from './CRow'\n\nexport { CCol, CContainer, CRow }\n";